import React, { FC, useMemo, useState } from 'react'
import { userFullName } from '../../../../shared/utils/userFullName'
import { Comment } from '../../../../shared/__gql-types'
import { CommentPreview } from './CommentPreview'
import { relativeDay } from '../../../../shared/utils/formatDate'
import EditComment from '../../../../modules/Feed/components/Comment/EditComment'
import { CommentActionsDropdown } from './CommentActionsDropdown'
import { useZonesList } from '../../../../modulesCommon/serviceHooks'

type TCommentContainerProps = {
  comment: Comment
  onEdit: (value: string) => void
  onDelete: () => void
  loading?: boolean
  allowEditing?: boolean
  allowDeletion?: boolean
}

export const CommentContainer: FC<TCommentContainerProps> = (props) => {
  const { comment, onEdit, onDelete, loading, allowEditing, allowDeletion } = props
  const { getZoneById } = useZonesList()
  const [isEditMode, setIsEditMode] = useState(false)

  const date = relativeDay(comment.updated_at)
  const actions = useMemo(() => {
    const allActions = [
      {
        key: 'edit',
        title: 'Edit Comment',
        action: () => setIsEditMode(true),
        visible: allowEditing
      },
      {
        key: 'delete',
        title: 'Delete Comment',
        action: onDelete,
        visible: allowDeletion
      }
    ]
    return allActions.filter((action) => action.visible)
  }, [allowEditing, allowDeletion, onDelete, setIsEditMode])

  return isEditMode ? (
    <EditComment loading={loading} text={comment.text} onSubmit={async (newText) => {
      await onEdit(newText)
      setIsEditMode(false)
    }} />
  ) : (
    <CommentPreview
      key={comment.id}
      date={date}
      author={userFullName(comment.author)}
      text={comment.text}
      zone={getZoneById(String(comment.author.label_id))?.name ?? ''}
      actions={
        actions.length > 0 ? (
          <CommentActionsDropdown
            actions={actions}
          />
        ) : null
      }
    />
  )
}


